import api from './api';

export const loginUser = async (credentials) => {
  try {
    // console.log('credentials: ',credentials);
    const response = await api.post('/auth/login', credentials);
    // console.log("Response Login termasuk token;", response);
    return response;
  } catch (error) {
    throw error;
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    // Clear token from localStorage
    localStorage.removeItem('token');
    return { success: true };
  } catch (error) {
    throw error;
  }
};

export const getProfile = async () => {
  try {
    const response = await api.get('/auth/profile');
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const changePassword = async (passwordData) => {
  try {
    const response = await api.post('/auth/change-password', passwordData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkAuthStatus = async () => {
  try {
    const response = await api.get('/auth/profile');
    return response.data.data;
  } catch (error) {
    throw error;
  }
}; 